// Dynamically pick text direction from content.
// Returns 'rtl' when the first strong (letter) character is Hebrew, otherwise 'ltr'.
// Leading whitespace, digits and punctuation are skipped so a note like "  שלום"
// or "\"שלום\"" is still detected as RTL.

const HEBREW_CHAR = /[֐-׿]/;
const STRONG_CHAR = /[A-Za-z֐-׿]/;

export const getTextDirection = (text?: string | null): 'rtl' | 'ltr' => {
    if (!text) return 'ltr';
    for (const ch of text) {
        if (STRONG_CHAR.test(ch)) {
            return HEBREW_CHAR.test(ch) ? 'rtl' : 'ltr';
        }
    }
    return 'ltr';
};
